import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

const ImpressumText = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 6
    }}
    {...props}
  >
    <Container
      maxWidth="md"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        px: {
          md: '130px !important'
        }
      }}
    >
      <Typography
        align="center"
        color="textPrimary"
        variant="h2"
        component="span"
      >
        Impressum
      </Typography>
      <Typography
        align="center"
        color="textSecondary"
        variant="body1"
        sx={{ py: 3 }}
      >
        <h2>eyerena – die neue digitale Plattform für ViCo Training</h2>
        <br />
        <h3>Angaben gemäß § 5 TMG:</h3>
        <br />
        <h4>Postanschrift</h4>
        Christian Odenthal
        <br />
        Albin-Hänseroth-Weg 69
        <br />
        50859 Köln
        <br />
        Deutschland
        <br />
        <br />
        <h4>Kontakt</h4>
        Internet: eyerena.com
        <br />
        E-Mail: hello@eyerena-training.de
        <br />
        <br />
        <h4>Vertreten durch</h4>
        Stefanie Hennigfeld, die Expertin
        <br />
        Christian Odenthal, der Entwickler
        <br />
        Ralf Kissels, der Unterstützer
        <br />
        <br />
        <br />
        <h4>Hinweise zur Webseite</h4>
        <h4>Information gemäß § 36 VSBG</h4>
        Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in Verbrauchersachen) erklärt der Betreiber dieser Webseite: Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Die Plattform finden Sie unter ec.europa.eu/consumers/odr/. Wir sind weder bereit noch verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        <br />
        <br />
        <br />
      </Typography>
    </Container>
  </Box>
);

export default ImpressumText;
